import React, { Suspense } from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Toast } from './components/Common/Toast';
import Home from './pages/Home/Home.jsx';
import Login from './pages/Users/Login.jsx';
import ProfileUpload from './pages/Users/ProfileUpload.jsx';
import VerifyProfile from './pages/Users/VerifyProfile.jsx';
import HobbiesInterests from './pages/Users/HobbiesInterests.jsx';
import FamilyDetailsForm from './pages/Users/FamilyDetailsForm.jsx';
import DashboardPage from './components/Dashboard/dashboard/DashboardPage.jsx';
import ForgotPasswordOTP from './pages/Users/forget-password/ForgotPasswordOTP.jsx';
import Matches from './components/Dashboard/Matches/Matches.jsx';
import Search from './components/Dashboard/search/Search.jsx';
import MessageInbox from './components/Dashboard/inboxmessage/MessageInbox.jsx';
import SearchResultsPage from './components/Dashboard/search/SearchResultsPage.jsx';
import ManageRequests from './components/Dashboard/inbox/ManageRequests.jsx';
import OnboardingLayout from './components/Layout/OnboardingLayout';
import DashboardLayout from './components/Layout/DashboardLayout';
import GeneticBiological from './components/Dashboard/dna/components/Biological.jsx';
import GeneticPhyscological from './components/Dashboard/dna/components/Psycholigical.jsx';
import GeneticBirthDefect from './components/Dashboard/dna/components/BirthDefect.jsx';
import UpgradeProfile from './components/UpgradeProfile/UpgradeProfile.jsx';
import PaymentSuccess from './components/UpgradeProfile/Success.jsx';
import PaymentCancel from './components/UpgradeProfile/Cancel.jsx';
import ScrollToTop from './components/Common/ScrollToTop';
import ProfilePage from './components/Dashboard/Matches/components/ProfilePage.jsx';
import Meeting from './pages/Meeting/Meeting.jsx';
import Teams from './pages/Teams/Teams.jsx';

import PrivacyPolicy from './pages/PrivacyPolicy.jsx';
import TermsOfService from './pages/TermOfService.jsx';
import DeleteSocialInstruction from './pages/DeleteSocialInstruction.jsx';
import SocialAuthSuccess from './components/Dashboard/dashboard/dashtabcomponents/SocialAuthSuccess.jsx';
import SocialAuthError from './components/Dashboard/dashboard/dashtabcomponents/SocialAuthError.jsx';
// Protected Route Wrapper for Onboarding routes
const OnboardingRoute = () => {
  const { token } = useSelector((state) => state.user);
  return token ? (
    <OnboardingLayout>
      <Outlet />
    </OnboardingLayout>
  ) : (
    <Navigate to="/login" replace />
  );
};

// Protected Route Wrapper for Dashboard routes
const DashboardRoute = () => {
  const { token } = useSelector((state) => state.user);
  return token ? (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  ) : (
    <Navigate to="/login" replace />
  );
};

function App() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Toast />
      <ScrollToTop />
      <Routes>
        {/* Public Routes */}
        {/* <Route path="/" element={<Home />} /> */}
        <Route path="/login" element={<Login />} />
        <Route path="/forget-password" element={<ForgotPasswordOTP />} />
        <Route path="/social-auth-callback" element={<SocialAuthSuccess />} />
        <Route path="/social-auth-error" element={<SocialAuthError />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/delete-social-account" element={<DeleteSocialInstruction />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        {/* Protected Routes */}
        {/* Onboarding Routes (with HeaderOnboarding) */}
        <Route element={<OnboardingRoute />}>
          <Route path="/profile-upload" element={<ProfileUpload />} />
          <Route path="/hobbies" element={<HobbiesInterests />} />
          <Route path="/verify-profile" element={<VerifyProfile />} />
          <Route path="/family-details" element={<FamilyDetailsForm />} />
        </Route>

        {/* Dashboard Routes (with HeaderDashboard) */}
        <Route element={<DashboardRoute />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/message-inbox" element={<MessageInbox />} />
          <Route path="/matches" element={<Matches />} />
          <Route path="/search-profile" element={<Search />} />
          <Route path="/search-results" element={<SearchResultsPage />} />
          <Route path="/manage-requests" element={<ManageRequests/>} />
          <Route path="/gentics-biological-attraction" element={<GeneticBiological />} />
          <Route path="/gentics-psychological-compatibility" element={<GeneticPhyscological />} />
          <Route path="/gentics-birth-defect-risk" element={<GeneticBirthDefect />} />
          <Route path="/upgrade-profile" element={<UpgradeProfile />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/profile/:profileId" element={<ProfilePage />} />
          <Route path="/meeting" element={<Meeting />} />
          <Route path="/teams" element={<Teams />} />
        </Route>
        {/* Catch-all redirect */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Suspense>
  );
}

export default App;